// خدمة إدارة التوكنات
class TokenService {
  constructor() {
    this.refreshPromise = null;
  }

  // حفظ التوكنات
  setTokens(accessToken, refreshToken) {
    localStorage.setItem('authToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  }

  // الحصول على التوكن الحالي
  getAccessToken() {
    return localStorage.getItem('authToken');
  }

  // الحصول على refresh token
  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  // حذف جميع التوكنات
  clearTokens() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }

  // التحقق من انتهاء صلاحية التوكن
  isTokenExpired(token) {
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  }

  // الحصول على وقت انتهاء صلاحية التوكن
  getTokenExpirationTime(token) {
    if (!token) return null;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp * 1000; // تحويل إلى milliseconds
    } catch (error) {
      return null;
    }
  }

  // تجديد التوكن
  async refreshAccessToken() {
    // تجنب طلبات متعددة متزامنة
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    this.refreshPromise = this.performTokenRefresh(refreshToken);
    
    try {
      const result = await this.refreshPromise;
      return result;
    } finally {
      this.refreshPromise = null;
    }
  }

  // تنفيذ تجديد التوكن
  async performTokenRefresh(refreshToken) {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    
    try {
      const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          refresh_token: refreshToken
        })
      });

      if (!response.ok) {
        throw new Error('Token refresh failed');
      }

      const data = await response.json();
      
      if (data.access_token) {
        this.setTokens(data.access_token, data.refresh_token || refreshToken);
        return data.access_token;
      } else {
        throw new Error('Invalid response from refresh endpoint');
      }
    } catch (error) {
      console.error('Token refresh error:', error);
      this.clearTokens();
      throw error;
    }
  }

  // التحقق من الحاجة لتجديد التوكن (قبل انتهاء الصلاحية بـ 5 دقائق)
  shouldRefreshToken(token) {
    if (!token) return false;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      const timeUntilExpiry = payload.exp - currentTime;
      
      // تجديد التوكن قبل انتهاء الصلاحية بـ 5 دقائق (300 ثانية)
      return timeUntilExpiry < 300;
    } catch (error) {
      return true;
    }
  }

  // تجديد التوكن التلقائي قبل انتهاء الصلاحية
  async autoRefreshToken() {
    const accessToken = this.getAccessToken();
    
    if (!accessToken) {
      return null;
    }

    // التحقق من الحاجة للتجديد
    if (this.shouldRefreshToken(accessToken)) {
      try {
        console.log('Auto-refreshing token before expiry...');
        return await this.refreshAccessToken();
      } catch (error) {
        console.error('Auto token refresh failed:', error);
        return null;
      }
    }

    return accessToken;
  }
}

// إنشاء instance واحد للخدمة
const tokenService = new TokenService();

export default tokenService;
